import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { SoftwareAdminApi, type SoftwareStatus } from 'openapi'

export const useSoftwareAdminList = (params: {
  offset?: number
  limit: number
  status?: SoftwareStatus
  ordering: string
  query?: string
  hasBlankVersionUrls?: boolean
  hasPendingVersions?: boolean
}) => {
  const { offset, limit, ordering, query, status, hasBlankVersionUrls, hasPendingVersions } = params

  return useQuery({
    queryKey: [
      'SoftwareAdminApi.list',
      limit,
      offset,
      status,
      ordering,
      query,
      hasBlankVersionUrls,
      hasPendingVersions,
    ],
    queryFn: async () => {
      return SoftwareAdminApi.list({ limit, offset, status, ordering, query, hasBlankVersionUrls, hasPendingVersions })
    },
    placeholderData: keepPreviousData,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
  })
}
